import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "en", label: "English", flag: "/flags/gb.png" },
  { code: "pt", label: "Português", flag: "/flags/pt.png" },
  { code: "es", label: "Español", flag: "/flags/es.png" },
];

const toggleButtonSx = (theme: any) => ({
  borderRadius: 2,
  border: `1px solid ${theme.palette.divider}`,
  py: 1,
  "&.Mui-selected": {
    backgroundColor: theme.palette.primary.main + "30",
    color: theme.palette.primary.main,
    fontWeight: 700,
    "&:hover": { backgroundColor: theme.palette.primary.main + "50" },
  },
  "&:hover": { backgroundColor: theme.palette.action.hover },
});

export default function LanguageToggle() {
  const { i18n } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      size="small"
      value={i18n.language.split("-")[0]}
      onChange={(_, value) => value && handleLanguageChange(value)}
    >
      {LANGUAGES.map((lang) => (
        <ToggleButton key={lang.code} value={lang.code} sx={toggleButtonSx}>
          <Stack alignItems="center" spacing={0.5}>
            <Box
              component="img"
              src={lang.flag}
              alt={lang.label}
              sx={{
                width: 20,
                height: 14,
                objectFit: "cover",
                borderRadius: 0.5,
                boxShadow: (theme) => `0 0 0 1px ${theme.palette.divider}`,
              }}
            />
            <Typography variant="caption" sx={{ fontSize: 10, fontWeight: "inherit" }}>
              {lang.code.toUpperCase()}
            </Typography>
          </Stack>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}